(function() {
    'use strict';

    angular.module('caffeprint')
        .directive('cpDataboxes', cpDataboxes);

    cpDataboxes.$inject = ['datatablePageSizesConst'];

    function cpDataboxes(datatablePageSizesConst) {
        return {
            restrict: 'E',
            replace: true,
            transclude: true,
            templateUrl: 'app/caffeprint/directives/databoxes/databoxes.html',
            scope: {
                title: '@',
                rows: '=',
                titleRow: '@',
                objects: '=',
                modelPermissions: '=?',
                showBadge: '=?',

                onCreate: '&?',
                onClick: '&?',

                pageOpts: '=?',
                pageChange: '&?'
            },
            link: function(scope, element, attrs, controller) {
                scope.pageSizeOpts = datatablePageSizesConst;
                scope.selectPageSizeChange = selectPageSizeChange;
                scope.inputPageSizeChange = inputPageSizeChange;
                scope.maxSize = 5;

                scope.click = click;

                function pageSizeChange() {
                    scope.pageOpts.page = 1;

                    if (scope.pageChange) {
                        scope.pageChange();
                    }
                }

                function selectPageSizeChange() {
                    scope.pageOpts.inputPageSize = undefined;
                    pageSizeChange();
                }

                function inputPageSizeChange() {
                    scope.pageOpts.pageSize = scope.pageOpts.inputPageSize;
                    pageSizeChange();
                }

                function click(object) {
                    if (scope.onClick) {
                        scope.onClick({
                            object: object
                        });
                    }
                }
            }
        };
    }
})();
